import { HTMLTable } from "@blueprintjs/core";
import { MDBBtn } from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { IResultadoSummary } from "../../../model";
import { LookupStore } from "../../../stores/LookupStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { sortBy } from "../../../utils";
import { observable } from "mobx";
import { AppStore } from "../../../stores/AppStore";
import { SpedApuracaoStore } from "../../../stores/sped/SpedApuracaoStore";
import { SpedStore } from "../../../stores/sped/SpedStore";
import Cookies from 'universal-cookie';

const cookies = new Cookies()
const numeral = require("numeral");

interface Props {
  onView(classId: number): void;
}

@observer
export class ResultadosSummary extends React.Component<Props, {}> {

  obs = observable({})

  /**
   * Salva no cookie "__DAE-DEI" as informações necessárias
   * (aba selecionada, empresa, período, data inicial e modelo)
   * e abre a página do SPED ou DEI em uma nova aba.
   */
  handleDaeDei(selectedTab: string) {

    cookies.set('__DAE-DEI', {
      tab: selectedTab,
      empresa: {
        cnpj: AppStore.obs1.selectedEmpresa.cnpj,
        razao_social: AppStore.obs1.selectedEmpresa.razao_social,
        uf: AppStore.obs1.selectedEmpresa.uf,
      },
      periodo: [ResultadoStore.obs.date_start, ResultadoStore.obs.date_end], 
      date_start: ResultadoStore.obs.date_start,
      modelo: ResultadoStore.obs.modelo
    }, { path: '/' });

    if (selectedTab == "dei") {

      window.open("/dei", "_blank")

    } else {
      
      window.open("/sped", "_blank")

    }

  }

  render() {
    let items = [];
    let totalValorProds = 0;
    let totalFcp = 0;
    let totalIcms = 0;
    let totalIcmsContest = 0;
    let totalAPagar = 0;

    for (let i = 0; i < ResultadoStore.obs.all_summary.length; i++) {
      let item = ResultadoStore.obs.all_summary[i];
      let value = LookupStore.getIcmsClassificacaoDAE(item.icms_classificacao_id)
      item.classificacao = value?.nome || "Sem classificação (itens não calculados)";
      item.dae = value?.dae_avulso || false;
      item.dei = value?.dei || false;
      item.codigo_receita = value?.codigo_receita || "";
    }

    let sorted: IResultadoSummary[] = sortBy(
      ResultadoStore.obs.all_summary,
      "classificacao",
    );

    for (let i = 0; i < sorted.length; i++) {
      let item = sorted[i];
      let classificacao = item.classificacao;
      let dae = item.dae;
      let dei = item.dei;
      let valorProds = item.valor;
      let icms = item.valor_icms;
      let valorFcp = item.valor_fcp;
      let icmsContest = item.valor_contestacao_icms;
      let aPagar = icms;
      if (item.classificacao == "Substituição Tributária") {
        aPagar = 0;
      }

      totalValorProds += valorProds;
      totalFcp += valorFcp;
      totalIcms += icms;
      totalIcmsContest += icmsContest;
      totalAPagar += aPagar - icmsContest;

      {
        classificacao == "Substituição Tributária" &&
          console.log("ST: " + icms);
      }

      items.push(
        <tr key={item.icms_classificacao_id}>
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={() => this.props.onView(item.icms_classificacao_id)}
            >
              <img src="/images/view.svg" width={25} />
            </MDBBtn>
          </td>
          <td>
            {classificacao}
          </td>
          <td style={{ textAlign: "right" }}>{numeral(valorProds).format("$ 0,0.00")}</td>
          <td style={{ textAlign: "right" }}>{numeral(valorFcp).format("$ 0,0.00")}</td>
          <td style={{ textAlign: "right" }}>{numeral(icms).format("$ 0,0.00")}</td>
          <td style={{ textAlign: "right" }}>{numeral(icmsContest).format("$ 0,0.00")}</td>
          <td style={{ textAlign: "right" }}>{numeral(aPagar - icmsContest).format("$ 0,0.00")}</td>
          <td style={{ textAlign: "right" }}>
            {dae && AppStore.obs1.selectedEmpresa.uf == "PA" && !AppStore.obs1.selectedEmpresa.simples_nacional ?
              <img style={{ cursor: "pointer" }} src="/images/share.png" width={20} onClick={() => this.handleDaeDei(ResultadoStore.obs.tipo == "Entrada" ? "apuracao_entrada" : "apuracao_saida")} />
              :
              <></>
            }
            {dei && AppStore.obs1.selectedEmpresa.uf == "PA" && AppStore.obs1.selectedEmpresa.simples_nacional ?
              <img style={{ cursor: "pointer" }} src="/images/share.png" width={20} onClick={() => this.handleDaeDei("dei")} />
              :
              <></>
            }
          </td>
        </tr>,
      );
    }

    items.push(
      <tr key="totals" className="nz-table-highlight">
        <td />
        <td style={{ textAlign: "left" }}>Totais</td>
        <td style={{ textAlign: "right" }}>{numeral(totalValorProds).format("$ 0,0.00")}</td>
        <td style={{ textAlign: "right" }}>{numeral(totalFcp).format("$ 0,0.00")}</td>
        <td style={{ textAlign: "right" }}>{numeral(totalIcms).format("$ 0,0.00")}</td>
        <td style={{ textAlign: "right" }}>{numeral(totalIcmsContest).format("$ 0,0.00")}</td>
        <td style={{ textAlign: "right" }}>{numeral(totalAPagar).format("$ 0,0.00")}
        </td>
        <td />
      </tr>,
    );

    return (
      <>

        <div className="TableDefault" style={{ marginBottom: 40 }}>
          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%" }}
            data-tut="resumo"
          >
            <thead>
              <tr>
                <th />
                <th style={{ maxWidth: "100%", textAlign: "left" }}>Classificação</th>
                <th style={{ textAlign: "right" }} className="number">Total produtos / receita</th>
                <th style={{ textAlign: "right" }} className="number">FCP Calculado (A pagar)</th>
                <th style={{ textAlign: "right" }} className="number">ICMS Calculado</th>
                <th style={{ textAlign: "right" }} className="number">Contestado</th>
                <th style={{ textAlign: "right" }} className="number">A pagar</th>
                <th style={{ textAlign: "right" }}>{AppStore.obs1.selectedEmpresa.simples_nacional ? "DEI" : "DAE"}</th>
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </HTMLTable>

        </div>

      </>
    );
  }
}
